import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd, PRIMARY_OUTLET } from '@angular/router';
import { QuizService } from 'src/app/shared-service/services/quiz.service';
import { UserService } from 'src/app/shared-service/services/user.service';
@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html'
})

export class BreadcrumbComponent implements OnInit {

  @Input()
  isMob=false;
  @Output()
  breadCrumEvent = new EventEmitter();

  public breadcrumbs: Breadcrumb[];
  routeParamsDataMap: {};
  routeParamsKeys: any;
  baseUrl = '';
  defaultBreadcrumb: Breadcrumb = {
    label: 'Home',
    url: ''
  };

  constructor(private router: Router, private route: ActivatedRoute, private userSerive: UserService,
    private quizService: QuizService) {
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
          let root: ActivatedRoute = this.route.root;
          this.routeParamsDataMap = route.snapshot.paramMap['params'];
          this.routeParamsKeys = route.snapshot.paramMap['keys'];
          let customTitle = route.snapshot.data['title'];
          if(customTitle == 'exam') {
            this.setBaseOnlineTestSeries();
            const currUrl = event.url;
            this.examCustmBreadCrum(currUrl);
          } else if(customTitle == 'exam_type') {
              this.setExamsTypeBase();
          } else if (customTitle === 'online-test-series' && this.routeParamsKeys && this.routeParamsKeys.length ==0) {
            this.setBaseOnlineTestSeries();
          } else if (this.routeParamsKeys[0] === 'online-test-cat') {
          } else if (this.routeParamsKeys[0] === 'online-sub-test-cat') {
            this.setBaseOnlineTestSeries();
            if(!this.userSerive.selectedPackage.hasOwnProperty('package_id')) {
              let initData;
              let catSubName =  this.routeParamsDataMap['online-sub-test-cat'].substring(0,this.routeParamsDataMap['online-sub-test-cat'].length - 19);
              this.quizService.getBreadCrumsInitData(catSubName).subscribe((res:any) => {
                if(res && res.state ==200) {
                  initData = res.data;
                  this.userSerive.selectedPackage = res.data[0];
                  this.setTestCatBreadCrum();
                  this.testCustomBreadCrum(this.routeParamsDataMap);
                }
              });
            } else {
              this.setTestCatBreadCrum();
              this.testCustomBreadCrum(this.routeParamsDataMap);
            }
          } else if (this.routeParamsKeys[0] === 'cat-ts') {
            this.setBaseOnlineTestSeries();
            this.privateCat_ts_BreadCrumbs(this.routeParamsDataMap);

          } else if (this.routeParamsKeys[0] === 'examTypeCat') {
            this.setExamsTypeBreadCrum();
          } else if (this.routeParamsKeys[1] === 'examSubCat') {
            this.setExamsPageBreadCrum();
          } else {
            this.breadcrumbs = this.getBreadcrumbs(root);
            this.getCustomBreadcrumbs(this.routeParamsDataMap);
            this.breadcrumbs = [this.defaultBreadcrumb, ...this.breadcrumbs];

          }
      }
    });
   }

  ngOnInit() {
  }

  private setExamsTypeBase() {
    var examType = location.pathname
    examType = examType.replace(/-/g, ' ');
    examType = examType.replace(/\//g, '');
    var label = examType.toUpperCase();
    let url = location.pathname;
    const breadcrumb: Breadcrumb = {
      label,
      url
    };
    this.breadcrumbs = [];
    this.breadcrumbs.push(breadcrumb);
    this.breadcrumbs = [this.defaultBreadcrumb, ...this.breadcrumbs];
  }


  private setExamsTypeBreadCrum() {
    var examSubCat = this.routeParamsDataMap["examTypeCat"];
    var label = examSubCat.toUpperCase();
    let url = location.pathname;
    const breadcrumb: Breadcrumb = {
      label,
      url
    };
    this.breadcrumbs = [];
    this.breadcrumbs.push(breadcrumb);
    this.breadcrumbs = [this.defaultBreadcrumb, ...this.breadcrumbs];
  }

  private setExamsPageBreadCrum() {
    var examSubCat = this.routeParamsDataMap["examSubCat"];
    examSubCat = examSubCat.split('-exam');
    var label = examSubCat[0].replace(/-/g,' ').toUpperCase();
    let url = "/"+this.routeParamsDataMap["examCat"]+"/"+examSubCat[0]+"-exam";
    const breadcrumb: Breadcrumb = {
      label,
      url
    };
    this.breadcrumbs = [];
    this.breadcrumbs.push(breadcrumb);
    //this.breadcrumbs = [this.defaultBreadcrumb, ...this.breadcrumbs];


    let label_exam = "";
    if(examSubCat && examSubCat.length > 1 && examSubCat[1]) {
      label_exam = examSubCat[1].replace(/-/g,' ').toUpperCase();
      let url_1 = "/"+this.routeParamsDataMap["examCat"]+"/"+this.routeParamsDataMap["examSubCat"];
      const breadcrumb_1: Breadcrumb = {
        label:label_exam,
        url:url_1
      };
      this.breadcrumbs.push(breadcrumb_1);
    }
    this.breadcrumbs = [this.defaultBreadcrumb, ...this.breadcrumbs];
  }

  private setBaseOnlineTestSeries() {
    let label = 'Online Test Series';
    let url = '/online-test-series';
    const breadcrumb: Breadcrumb = {
      label,
      url
    };
    this.breadcrumbs = [];
    this.breadcrumbs.push(breadcrumb);
    this.breadcrumbs = [this.defaultBreadcrumb, ...this.breadcrumbs];
  }

  private setTestCatBreadCrum() {
      let testCat = this.userSerive.selectedPackage['package_main_exam'];
      testCat = testCat.toLowerCase();
      testCat = testCat.replace(/ /g, '-');
      var label = this.userSerive.selectedPackage['package_main_exam'];
      var url =   '/' + testCat.toLowerCase() + '/online-test-series';
      label = label.replace('-2021', '');
      url = url.replace('-2021', '');
      const breadcrumb: Breadcrumb = {
        label,
        url
      };
      this.breadcrumbs.push(breadcrumb);
  }

  private testCustomBreadCrum(paramMap) {
    let label = '';
    let url = '';
    let categoryName = paramMap['online-sub-test-cat'];
    categoryName = categoryName.substring(0, categoryName.indexOf("-online-test-series"));
    let capitalize = categoryName.split('-');
    let capitalName = '';
    capitalize.forEach(item => {
      capitalName = capitalName + item.toUpperCase() + ' ';
    });
    label = capitalName + '';
    url = '/' + paramMap['online-sub-test-cat'];
    const breadcrumb: Breadcrumb = {
      label,
      url
    };
    this.breadcrumbs.push(breadcrumb);
  }
  private examCustmBreadCrum(currUrl) {
    let cuurl = currUrl.split('/');
    let label = '';
    let url = currUrl;
    if(cuurl.length >= 2) {
      let capitalize = cuurl[2].split('-');
      let capitalName = '';
      capitalize.forEach(item => {
        capitalName = capitalName + item.toUpperCase() + ' ';
      });
      label = capitalName + '';
    }
    const breadcrumb: Breadcrumb = {
      label,
      url
    };
    this.breadcrumbs = [];
    this.breadcrumbs.push(breadcrumb);
    this.breadcrumbs = [this.defaultBreadcrumb, ...this.breadcrumbs];
  }
  privateCat_ts_BreadCrumbs(paramMap) {
    let label = '';
    let url = '';
    for (const [key, value] of Object.entries(paramMap)) {
      let custLabel = value + '';
      if(custLabel.indexOf('-') !== -1) {
        let labelArray = custLabel.split('-');
        custLabel = '';
        labelArray.forEach(item => custLabel = custLabel + item.charAt(0).toUpperCase() + item.slice(1) + ' ');
      } else {
        if (custLabel === 'ssc') {
          custLabel = custLabel.toUpperCase();
        } else {
          custLabel = custLabel.charAt(0).toUpperCase() + custLabel.slice(1);
        }
      }
      label = custLabel;
      url = '/' + value + '/online-test-series';
    }
    if (url !== '') {
      url = this.baseUrl + url;
      const breadcrumb: Breadcrumb = {
        label,
        url
      };
      this.breadcrumbs.push(breadcrumb);
    }
  }

  private getCustomBreadcrumbs(paramMap) {
    let label = '';
    let url = '';
    for (const [key, value] of Object.entries(paramMap)) {
      label = value + '';
      url = url + '/' + value;
    }
    if (url !== '') {
      url = this.baseUrl + url;
      const breadcrumb: Breadcrumb = {
        label,
        url
      };
      this.breadcrumbs.push(breadcrumb);
    }
  }


  private getBreadcrumbs(route: ActivatedRoute, url: string = "", breadcrumbs: Breadcrumb[] = []): Breadcrumb[] {
    const ROUTE_DATA_BREADCRUMB = 'title';
    let children: ActivatedRoute[] = route.children;
    if (children.length === 0) {
      return breadcrumbs;
    }
    for (let child of children) {
      if (child.outlet !== PRIMARY_OUTLET || child.snapshot.url.length==0) {
        continue;
      }
      if (!child.snapshot.data.hasOwnProperty(ROUTE_DATA_BREADCRUMB)) {
        return this.getBreadcrumbs(child, url, breadcrumbs);
      }
      let routeURL: string = child.snapshot.url.map(segment => segment.path).join("/");
      url += `/${routeURL}`;
      let urlParts = url.split("/");
      if(urlParts.length > 0) {
        url = '/' + urlParts[1];
      }
      this.baseUrl = url;
      let breadcrumb: Breadcrumb = {
        label: child.snapshot.data[ROUTE_DATA_BREADCRUMB],
        url: url
      };
      breadcrumbs.push(breadcrumb);
      return this.getBreadcrumbs(child, url, breadcrumbs);
    }
    return breadcrumbs;
  }


  breadCrumClicked(data) {
    this.breadCrumEvent.emit(data);
  }

}

export interface Breadcrumb {
  label: string;
    url: string;
}
